import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { bookNewbuildingAction, closeNewbuildingBookingConfirm } from '../../../actions/newbuildingBooking';
import { NewbuildingBookingModal } from '../../../components/NewbuildingBookingModal';
import {
  selectIsBookingError,
  selectIsBookingLoading,
  selectIsConfirmOpen,
} from '../../../selectors/newbuildingBooking';
import { selectBookingDetails } from '../../../selectors/profitbaseBooking';

export const BookingConfirmModalContainer = () => {
  const isOpen = useSelector(selectIsConfirmOpen);
  const isError = useSelector(selectIsBookingError);
  const isLoading = useSelector(selectIsBookingLoading);
  const details = useSelector(selectBookingDetails);
  const dispatch = useDispatch();

  const handleClose = React.useCallback(() => {
    dispatch(closeNewbuildingBookingConfirm());
  }, [dispatch]);

  const handleConfirm = React.useCallback(() => {
    dispatch(bookNewbuildingAction());
  }, [dispatch]);

  return (
    <NewbuildingBookingModal
      details={details}
      open={isOpen}
      error={isError}
      loading={isLoading}
      onClose={handleClose}
      onConfirm={handleConfirm}
    />
  );
};
